<template>
  <div class="diy-article">
    <div :class="'article-item show-type__'+item.show_type" v-for="(item,index) in datalist" :key="index" @click="onTargetDetail(item.article_id)">
      <!-- 小图模式 -->
      <div v-if="item.show_type == 10" style="width:100%">
        <div class="article-item__left flex-box">
          <div class="article-item__title twolist-hidden">
            <p class="f-30 col-3">{{item.article_title}}</p>
          </div>
          <div class="article-item__footer m-top10">
            <p class="article-divs f-24 col-8">{{item.virtual_views}}次浏览</p>
          </div>
        </div>
        <div class="article-item__image">
          <img :src="item.image.file_path | thumbnail(240,240)">
        </div>
      </div>
      <!-- 大图模式 -->
      <div v-if="item.show_type == 20" style="width:100%">
        <div class="article-item__title">
          <p class="f-30 col-3">{{ item.article_title }}</p>
        </div>
        <div class="article-item__image m-top20">
          <img :src="item.image.file_path | thumbnail(750,750)">
        </div>
        <div class="article-item__footer m-top10">
          <p class="article-divs f-24 col-8">{{ item.virtual_views }}次浏览</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params","datalist"],
  created(){
  },
  activated() {
  },
  methods:{
    onTargetDetail(id){
      this.$router.push({
        path:'/pages/article/detail/index',
        query:{
          article_id:id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.diy-article {
  background: #f7f7f7;
}

.diy-article .article-item {
  margin-bottom: 10px;
  padding: 15px;
  background: #fff;
}

.diy-article .article-item:last-child {
  margin-bottom: 0;
}

.diy-article .article-item .article-item__image img {
  display: block;
}

.article-item__image{
  width: 100%;
}
/* 小图模式 */

.show-type__10 {
  display: flex;
}

.show-type__10 .article-item__left {
  padding-right: 10px;
}

.show-type__10 .article-item__title {
  min-height: 36px;
}

.show-type__10 .article-item__image img {
  display: block;
  margin: auto auto;
  width: 120px;
}

/* 大图模式 */

.show-type__20 .article-item__image img {
  width: 100%;
}

</style>